export type LiveRegionState = {
  message: string;
  role?: string;
};

export type LiveRegionRefType = {
  broadcast: ({ message, role }: LiveRegionState) => void;
};

export type LiveRegionProps = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook?: string;
  /** Specifies a CSS class name to be appended to the component’s root element */
  className?: string;
};
